import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TicketService {
  private ticketUrl = environment.apiUrl + 'portal/tickets/';
  constructor(private http: HttpClient) { }

  add(ticketDto: any): Observable<any> {
    return this.http.post(`${this.ticketUrl}`, {...ticketDto });
  }

  update(id: number, ticketDto: any): Observable<any> {
    return this.http.put(`${this.ticketUrl}${id}`, {...ticketDto });
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.ticketUrl}${id}`);
  }

  getAll(pageNumber: number, pageSize: number, search?: string): Observable<any> {
    return this.http.get(`${this.ticketUrl}?page_number=${pageNumber}&page_size=${pageSize}&search=${search}`);
  }
  
  getById(id: number): Observable<any> {
    return this.http.get(`${this.ticketUrl}${id}`);
  }

  deleteAttachment(ticketId: number, attachmentId: string) {
    return this.http.delete(`${this.ticketUrl}${ticketId}/attachments/${attachmentId}`);
  }


}
